import { QueryClient } from "@tanstack/react-query";

import { fetchLayoutNesting } from "#modules/layouts/infra/fetchLayoutNesting.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { NestingRunView } from "shared";

export const layoutNestingQuery = (layoutId: string | undefined | null) => ({
  queryKey: queryKeys.layoutNestings.detail(layoutId),
  queryFn: () => fetchLayoutNesting(layoutId || ""),
  enabled: !!layoutId,
});

export const setLayoutNestingQueryData = (
  queryClient: QueryClient,
  layoutId: string,
  nestingRun: NestingRunView,
): NestingRunView | undefined => {
  return (
    queryClient.setQueryData<NestingRunView | null>(
      queryKeys.layoutNestings.detail(layoutId),
      nestingRun,
    ) ?? undefined
  );
};
